import React, { useState } from 'react';
import ConsumablesModal from './consumablesModal';

export const ConsumablesContext = React.createContext(null);

const Consumables = ({ showModal, setShowModal }) => {
  const listStep: string = 'list';
  const pointsSummaryStep: string = 'pointsSummary';
  const [consumablesStep, setConsumablesStep] = useState(listStep);
  const [scannedConsumableVariant, setScannedConsumableVariant] =
    useState(null);
  const [customerCoupons, setCustomerCoupons] = useState([]);
  const [selectedCustomerCoupon, setSelectedCustomerCoupon] =
    useState(undefined);
  const [newCoupon, setNewCoupon] = useState(null);
  const [welcome, setWelcome] = useState(false);
  const [isDI, setIsDI] = useState(false);
  const [skipCoupon, setSkipCoupon] = useState(false);

  return (
    <ConsumablesContext.Provider
      value={{
        showModal,
        setShowModal,
        consumablesStep,
        setConsumablesStep,
        listStep,
        pointsSummaryStep,
        scannedConsumableVariant,
        setScannedConsumableVariant,
        customerCoupons,
        setCustomerCoupons,
        selectedCustomerCoupon,
        setSelectedCustomerCoupon,
        newCoupon,
        setNewCoupon,
        setWelcome,
        welcome,
        setIsDI,
        isDI,
        skipCoupon,
        setSkipCoupon,
      }}>
      <ConsumablesModal />
    </ConsumablesContext.Provider>
  );
};

export default Consumables;
